import React from 'react';
import '../assets/css/Footer.css';
import { Link } from 'react-router-dom';
import EtawaTimesLogo from '../assets/images/logo/etawah-times-logo-new.png';

const Footer = () => {
    return (
        <footer id="contact">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section about">                     
                        <Link className="navbar-brand" to="/">
                            <img className='etawa-logo' src={EtawaTimesLogo} alt='Cawels electric logo' />
                        </Link>
                        <div className="contact-info">
                        </div>
	                <div className="social-icons">
                            <a href="https://www.facebook.com/share/1EJwazuFpM/" target="_blank" className="social-icon">
                                <i className="fab fa-facebook"></i>
                            </a>
                            <button className="social-icon">
                                <i className="fab fa-instagram"></i>
                            </button>
                            <button className="social-icon">
                                <i className="fab fa-twitter"></i>
                            </button>
                            <button className="social-icon">
                                <i className="fab fa-linkedin"></i>
                            </button>
                        </div>
                    </div>
                    <div className="footer-section links">
                        <h3>Quick Links</h3>
                        <ul>
                            <li>
                                <Link className="nav-link active" to="/">Home</Link>
                            </li>
                            <li><Link className="nav-link" to="/news">News</Link></li>
                            <li><Link className="nav-link" to="/about">About</Link></li>
                            {/* <li><a href="#services">Services</a></li> */}
                            <li><Link className="nav-link" to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                    <div className="footer-section contact-form">
                        <h3>Contact Us</h3>
                        <p><i className="fas fa-map-marker-alt"></i>237 सिविल लाइन्स, इटावा (उ.प्र.) विशाल प्रिंटर्स, 59 नौरंगाबाद, इटावा (उ.प्र.)</p>
                        <p><i className="fas fa-envelope"></i> info@etawahtimes.com</p>
                        <p><i className="fas fa-phone"></i>+91 9412320994</p>    
	            </div>
                </div>
                <div className="footer-bottom">                    
	            <p className='mb-0'>&copy; Copyright 2026 by Etawah Times | Maintained by <a href='https://logiquecode.com/' target="_blank" className='copyright-by'>LogiqueCode</a></p>  
                </div>
            </div>
        </footer>
    );
};

export default Footer;
